module.exports = __webpack_public_path__ + "media/musicbg.5abf0445.mp3";